// extracted by mini-css-extract-plugin
module.exports = {"copy":"Header_copy__31BXx"};